import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import FieldError from '../FieldError';
import FieldHint from '../FieldHint';
import { getLabel } from '../utils';

const CheckboxCollection = React.forwardRef((
    { hint, error, label, collection, name, required, value, onChange },
    ref,
) => {
    label = getLabel(label, name, required);

    const inputClasses = classNames({
        'ml-form-field': true,
        'ml-form-field-checkboxes': true,
        'error': error && error.length > 0,
    });

    const handleChange = React.useCallback((e) => {
        let newValue;
        if (e.target.checked) {
            newValue = [...value, e.target.value];
        } else {
            newValue = value.filter((i) => i !== e.target.value);
        }

        onChange(newValue);
    }, [value, onChange]);

    return (
        <Row as="fieldset" className={inputClasses}>
            <Col as="legend" xs={12}>{ label }</Col>
            {
                collection.map((i) => (
                    <Col
                        key={i.id}
                        xs={12}
                        md={6}
                        lg={4}
                        xl={3}
                    >
                        <div className="ml-form-field-checkboxes-group">
                            <input
                                key={i.id}
                                ref={ref}
                                checked={value.includes(i.id)}
                                id={`${name}_${i.id}`}
                                name={name}
                                type="checkbox"
                                value={i.id}
                                onChange={handleChange}
                            />
                            <label htmlFor={`${name}_${i.id}`}>{i.title}</label>
                        </div>
                    </Col>
                ))
            }
            <Col xs={12}>
                <FieldHint hint={hint} />
                <FieldError error={error} />
            </Col>
        </Row>
    );
});

CheckboxCollection.propTypes = {
    collection: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string.isRequired,
    })),
    error: PropTypes.string,
    hint: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    required: PropTypes.bool,
    value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    onChange: PropTypes.func.isRequired,
};

export default React.memo(CheckboxCollection);
